import React from 'react'
import { makeStyles } from "@mui/styles";
import { RED_COLOR } from '../../theme/colors';

const styles = makeStyles({
    button:{
        backgroundColor:RED_COLOR,
        color:"white",
        fontSize:"14px",
        padding:"0.5rem 1.2rem",
        border:"none",
        borderRadius:"8px",
        marginLeft:"0.6rem",
        cursor:"pointer",
        boxShadow:"0px 9px 20px #ff16543c",
        fontFamily:"inter_400"
    }
})

const RedShadowButton = ({ message }) => {

    const classes = styles();
    return <button className={ classes.button }  >
        { message }
    </button>
}

export default RedShadowButton;